export enum MessagingTokenPlatform {
	web = 'web',
	mobile = 'mobile',
}
